<template>   
    <div class="z-5 bg-white pa3" style="width:500px;">
        <div>
            <div class="flex justify-between mb3">
                <h3>Ask a question.</h3>
                <img @click="$emit('cancel')" class="grow pointer" src="@/assets/img/icon_x.svg"/>   
            </div>
            <textarea placeholder="Type message here." v-model="messageText" rows="8" class="pa3 w-100" v-focus.lazy="lg"></textarea>
                
        </div>
        <div class="flex mt3">
            <TooliabaButton :enabled="messageText !== ''" @click="submitQuestion" class="w-100 mr3">Send Message</TooliabaButton>
            <BlackButton @click="$emit('cancel')" class="w-100">Cancel</BlackButton>
        </div>
    </div>
</template>

<script>
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import BlackButton from '@/components/buttons/BlackButton.vue';
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            messageText: ''
        };
    },
    components: {
        TooliabaButton,
        BlackButton
    },
    props: {
        ownerId: {
            type: Number
        }
    },
    methods: {
        ...mapActions('messages', ['sendMessage']),
        submitQuestion() {
            this.sendMessage({
                text: this.messageText,
                contactId: this.ownerId
            });
            this.$emit('cancel');
        }
    }
};
</script>
